<template>
  <div class="expense-entry-page pharmacy-expense-entry-page">

    <!-- Header Card -->
        <PageHeader icon="fas fa-prescription-bottle-alt">
      <template #title>
        Tambah Pengeluaran Apotek
      </template>
      <template #subtitle>
        Catat transaksi pengeluaran operasional apotek dengan informasi yang lengkap
      </template>
    </PageHeader>

    <div class="row">
      <div class="col-md-12">
        <Card :card-class="'expense-entry-card'">
          <template v-slot:body>
            <Form :form="form" route="pharmacy-expenses" />
          </template>
        </Card>
      </div>
    </div>

  </div>
</template>

<script>

import Card from '@/view/content/Card.vue'
import Form from '@/component/pharmacy/pharmacy-expenses/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    Form
  },

  data() {
    return {
      // Form
      form: {
        date: window.medhopToday(),
        name: '',
        amount: '',
        pharmacy_expense_category_id: '',
        expense_method: '1',
        expense_method_type: '1',
        notes: '',
        photo: [],
        photo_name: "/images/default-expense.svg"
      },
    }
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Apotek", route:"/pharmacy/dashboard" },
      { title: "Pengeluaran", route: "/pharmacy/pharmacy-expenses/list" },
      { title: "Tambah Pengeluaran" },
    ])
  },

}
</script>

<style lang="scss" src="@/assets/sass/pages/_expense-entry-page.scss"></style>
